import Vue from 'vue'
import apiUrl from '@/common/apiUrl'
import webApiUtil from '@/common/webApiUtil'

export default {
  namespaced: true,
  state: {
    dataAllList: {
      totalRows: 0,
      list: []
    },
    accountDetail: {},
    userDetail: {}
  },
  mutations: {
    setAccountDetail: (state, accountDetail) => {
      state.accountDetail = accountDetail
    },
    setUserDetail: (state, userDetail) => {
      state.userDetail = userDetail
    },
    setResultDataList: (state, data) => {
      state.dataAllList.totalRows = data.totalRows
      state.dataAllList.list = data.dataList
    }
  },
  getters: {
    getAccountDetail: state => {
      return state.accountDetail
    }
  },
  actions: {
    getUserDetail: async ({commit, rootState}, userId = null) => {
      let userDetail = {}
      try {
        rootState.isLoading = true
        const url = apiUrl.userList
        const _param = {
          current_page: 1,
          page_size: 1,
          filter: {
            user_ids: [userId ? userId : Vue.$cookies.get('userInfo')['userId']]
          }
        }
        const res = await webApiUtil.post(url, _param)
        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          userDetail = res.data['users'][0]
        } else {
          userDetail = {}
        }
      } catch (e) {
        userDetail = {}
      } finally {
        rootState.isLoading = false
      }

      if (userId) {
        commit('setUserDetail', userDetail)
      } else {
        commit('setAccountDetail', userDetail)
      }
    },
    getDataList: async ({commit}, _params = {}) => {
      let resData = {}
      try {
        const url = apiUrl.userList
        const res = await webApiUtil.post(url, _params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          resData['totalRows'] = res.data['total_record']
          resData['dataList'] = res.data['users']
        } else {
          resData['totalRows'] = 0
          resData['dataList'] = []
        }
      }
      catch (e) {
        resData['totalRows'] = 0
        resData['dataList'] = []
      }

      commit('setResultDataList', resData)
    },
    updateOnCellTable: async (context, _params = {}) => {
      try {
        const url = apiUrl.userUpdate
        const res = await webApiUtil.post(url, _params, {}, true)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return 'updateOnCellTableSuccess'
        } else {
          return null
        }
      }
      catch (e) {
        return null
      }
    },
    deleteSelectedList: async (context, _params = []) => {
      try {
        const url = apiUrl.userDelete
        let params = {}
        if (_params && _params.length) {
          params['delete_ids'] = _params

          const res = await webApiUtil.post(url, params)

          if (res && res.data) {
            if (res.data.status === 0 && res.data.message !== 'No Data') {
              return 'deleteSelectedTableSuccess'
            } else {
              return res
            }
          } else {
            return null
          }
        }
      }
      catch (e) {
        return null
      }
    }
  }
}
